// Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from "../assets/logo.png"

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPrivacyDropdownOpen, setIsPrivacyDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsPrivacyDropdownOpen(false);
  };

  const togglePrivacyDropdown = (e) => {
    e.preventDefault();
    setIsPrivacyDropdownOpen(!isPrivacyDropdownOpen);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img className='logo' src={logo} alt="Logo"/>உலகத் தமிழர்
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <div className={isMenuOpen ? 'hamburger active' : 'hamburger'}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/ourapps" className="nav-link" onClick={closeMenu}>
              Our Apps
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          {/* <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={closeMenu}>
              Contact
            </Link>
          </li> */}
          {/* <li className="nav-item nav-item-dropdown">
            <a 
              href="#" 
              className="nav-link" 
              onClick={togglePrivacyDropdown}
              role="button"
            >
              Privacy policy
              <span className={`dropdown-arrow ${isPrivacyDropdownOpen ? 'open' : ''}`}></span>
            </a>
            <ul className={`dropdown-menu ${isPrivacyDropdownOpen ? 'active' : ''}`}>
              <li className="dropdown-item">
                <Link to="/privacy/sollaisol" className="dropdown-link" onClick={closeMenu}>
                  Sollai Sol
                </Link>
              </li>
            </ul>
          </li> */}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
